import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  card: theme.card,
  // username: {
  //   color: "#58595b",
  //   paddingTop: 10,
  //   paddingBottom: 10,
  // },
  formControl: {
    margin: theme.spacing(2),
    minWidth: 320,
    "& .MuiButtonBase-root":{paddingLeft:0}
  },
  left: {
    textAlign: "left",
  },
  button: {
    margin: theme.spacing(2),
  },
}));

export default useStyles;
